import {defineMessages} from 'react-intl';

export default defineMessages({
  required: {
    id: 'BaseFormItem.required',
    defaultMessage: 'This input is required',
  },
});
